import { createFileRoute, notFound } from '@tanstack/react-router';
import { RequireAccess } from '@/features/auth/RequireAccess';
import { BoardYearShell } from '@/features/dashboard/BoardYearShell';
import { MyParishPanel } from '@/features/dashboard/MyParishPanel';
import { useParishBoardData } from '@/features/dashboard/useParishBoardData';

export const Route = createFileRoute('/_app/parafia/$number')({
  loader: ({ params }) => {
    const parishNumber = Number(params.number);
    if (!Number.isInteger(parishNumber)) throw notFound();
    return { parishNumber };
  },
  component: ParishRoute,
});

// Profil parafii oglądany z konta diecezji (linki z tabeli „Moje parafie").
// Bramka UX, nie autoryzacja — backend i tak scope'uje listy po tokenie.
function ParishRoute() {
  return (
    <RequireAccess allow={(session) => session.scope.kind === 'diocese'}>
      <ParishContent />
    </RequireAccess>
  );
}

/** Nazwa parafii w okruszku (dane z tych samych, już pobranych list co panel). */
function ParishCrumb({ year, parishNumber }: { year: number; parishNumber: number }) {
  return <>{useParishBoardData(year, parishNumber).title}</>;
}

function ParishContent() {
  const { parishNumber } = Route.useLoaderData();
  return (
    <BoardYearShell
      crumb={(year) =>
        year === undefined ? null : (
          <ParishCrumb year={year} parishNumber={parishNumber} />
        )
      }
    >
      {(year) => <MyParishPanel year={year} parishNumber={parishNumber} />}
    </BoardYearShell>
  );
}
